<template>
  <div class="card">
    <div
      v-for="(plan, index) in _parentThis.planList"
      :key="index"
      class="plan-item"
      @click="selectPlan(plan)"
      :class="{ active: selectedPlan && selectedPlan.id === plan.id }"
    >
      <div class="plan-name">{{ plan.planName || '未命名计划' }}</div>
      <div class="plan-meta plan-time">{{ plan.planNo || '暂无计划号' }}</div>
      <div class="plan-meta plan-time">{{ plan.intervalStartTime }} — {{ plan.intervalEndTime }}</div>
      <div class="plan-actions" @click.stop>
        <el-button
          class="chip chip--status"
          :type="getStatusType(plan.planState)"
          plain
          size="mini"
        >{{ getStatusClass(plan.planState) }}</el-button>
        <el-button class="chip chip--type" type="primary" plain size="mini">{{ findItemByType(plan.businessType) }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["_parentThis"],
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  watch: {
    value (nVal) {
      nVal && this.selectPlan({ id: nVal });
    }
  },
  data () {
    return {
      planList: [
        {
          id: 'P202401150001',
          name: '宁夏煤炭运输计划A',
          timeRange: '2025.09.20 - 2025.09.21',
          status: '进行中',
          startTime: '2025-09-20 08:00',
          updateTime: '2025-09-20 10:30'
        }
      ],
      selectedPlan: null,
    };
  },
  methods: {
    getStatusClass (status) {
      let statusName
      switch (status + '') {
        case '2':
          statusName = '已完成';
          break
        case '1':
          statusName = '进行中';
          break
        case '0':
          statusName = '未开始';
          break
      }
      return statusName
    },
    getBusinessType () {

    },
    getStatusType (status) {
      const map = {
        '2': 'success',
        '1': 'warning',
        '0': 'info'
      }
      return map[status + ''] || 'info'
    },
    findItemByType (key) {
      if (!key) return ''
      const { businessType } = this.$store.getters.commonDict
      const item = businessType.find(item => item.dictKey == key);
      return item.dictValue||''
    },
    selectPlan (plan) {
      this.$emit('selectPlan', plan)
      this.selectedPlan = plan;
    },
  },
  mounted () { }
};
</script>

<style lang="scss" scoped>
.card {
  background: white;
  border-radius: 2px;
  //box-shadow: 0 24px 48px -38px rgba(31, 43, 77, 0.95);
  padding: 18px 10px;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  //&::before {
  //  content: "计划列表";
  //  font-size: 16px;
  //  font-weight: 600;
  //  color: #1f2b4d;
  //  letter-spacing: 0.4px;
  //  margin-bottom: 12px;
  //}

  &:hover {
    box-shadow: 0 30px 58px -36px rgba(31, 43, 77, 0.9);
  }

  .plan-item {
    padding: 18px 18px 10px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    border: 1px solid #e2e7f3;
    display: flex;
    flex-direction: column;
    min-height: 150px;

    & + .plan-item {
      margin-top: 12px;
    }

    &::before {
      content: "";
      position: absolute;
      top: 6px;
      bottom: 6px;
      left: 0;
      width: 4px;
      border-radius: 4px;
      background: #3d68ff;
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 14px 32px -26px rgba(31, 43, 77, 0.45);
    }

    &.active {
      //border-color: rgba(61, 104, 255, 0.55);
      //background: linear-gradient(90deg, rgba(61, 104, 255, 0.12), #ffffff);
      //box-shadow: 0 18px 36px -30px rgba(61, 104, 255, 0.55);
      background: #f8faff;
      &::before {
        opacity: 1;
      }
    }
  }

  .plan-name {
    font-size: 14px;
    font-weight: 600;
    color: #1a2440;
  }

  .plan-meta {
    font-size: 13px;
    color: #5a6582;
    margin-top: 6px;
    line-height: 18px;

    &.plan-time {
      color: #6f7a92;
    }
  }

  .plan-actions {
    margin-top: auto;
    display: flex;
    gap: 10px;
    align-items: center;
    padding-top: 14px;

    .el-button {
      border-radius: 16px;
      padding: 6px 18px;
      font-size: 12px;
      font-weight: 500;
      border: none;
      transition: transform 0.2s ease;

      &:hover {
        transform: translateY(-1px);
      }
    }

    .chip--type {
      background-color: rgba(56, 96, 255, 0.12) !important;
      border-color: rgba(56, 96, 255, 0.25) !important;
      color: #2f4fff !important;
    }

    .chip--status--info {
      background-color: rgba(37, 99, 235, 0.12) !important;
      border-color: rgba(37, 99, 235, 0.24) !important;
      color: #2563eb !important;
    }

    .chip--status--warning {
      background-color: rgba(245, 158, 11, 0.16) !important;
      border-color: rgba(245, 158, 11, 0.28) !important;
      color: #f59e0b !important;
    }

    .chip--status--success {
      background-color: rgba(22, 163, 74, 0.18) !important;
      border-color: rgba(22, 163, 74, 0.3) !important;
      color: #16a34a !important;
    }
  }
}
</style>
